import React from 'react';

import './EditPanelButtonGroup.css';

const EditPanelButtonGroup = ({ className = 'EditPanelButtonGroup', children }) => (
  <div className={className}>{children}</div>
);

export default EditPanelButtonGroup;
